import { ChangeEventHandler, FocusEventHandler, ReactNode, Ref } from "react";

type Props = SelectProps | InputProps;

type SelectProps = IconProps & {
  type: "select";
  onChange?: ChangeEventHandler<HTMLSelectElement>;
  onBlur?: FocusEventHandler<HTMLSelectElement>;
  children?: ReactNode;
};

type InputProps = IconProps & {
  type?: undefined;
  placeholder?: string;
  refProp?: Ref<HTMLInputElement>;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  onFocus?: FocusEventHandler<HTMLInputElement>;
  onBlur?: FocusEventHandler<HTMLInputElement>;
};

// The icons are background images on the control itself, so the caller gives
// the padding that keeps the text clear of them.
type IconProps = {
  id?: string;
  name?: string;
  className?: string;
  // Callers clear the selection by passing null, which React's `value` refuses;
  // both null and undefined leave the control uncontrolled.
  value?: string | number | null;
  disabled?: boolean;
  leftImage?: string;
  rightImage?: string;
  paddingLeft?: string;
  backgroundSize?: string;
  width?: string;
};

export default function ElementWithIcons(props: Props) {
  if (props.type === "select") {
    return (
      <select
        id={props.id}
        name={props.name}
        onChange={props.onChange}
        onBlur={props.onBlur}
        value={props.value ?? undefined}
        disabled={props.disabled}
        className={props.className}
        style={getStyle(props)}
      >
        {props.children}
      </select>
    );
  }

  return (
    <input
      type="text"
      id={props.id}
      name={props.name}
      placeholder={props.placeholder}
      ref={props.refProp}
      onChange={props.onChange}
      onFocus={props.onFocus}
      onBlur={props.onBlur}
      value={props.value ?? undefined}
      disabled={props.disabled}
      className={props.className}
      style={getStyle(props)}
    />
  );
}

function getStyle(props: IconProps) {
  let backgroundImage = "",
    backgroundPosition = "",
    backgroundRepeat = "";
  if (props.leftImage) {
    backgroundImage += 'url("' + props.leftImage + '")';
    backgroundPosition += "10px 50%";
    backgroundRepeat += "no-repeat";
  }
  if (props.rightImage) {
    if (props.leftImage) {
      backgroundImage += ", ";
      backgroundPosition += ", ";
      backgroundRepeat += ", ";
    }
    backgroundImage += 'url("' + props.rightImage + '")';
    backgroundPosition += "calc(100% - 10px) 50%";
    backgroundRepeat += "no-repeat";
  }
  return {
    paddingLeft: props.paddingLeft || (props.leftImage ? "35px" : ""),
    backgroundImage: backgroundImage,
    backgroundRepeat: backgroundRepeat,
    backgroundPosition: backgroundPosition,
    backgroundSize: props.backgroundSize || "18px",
    width: props.width || "100%",
  };
}
